import {makeAutoObservable} from 'mobx'
import Institution from './Institution'
import CodeObject from './CodeObject'

export default class Student {
  id: number

  firstName?: string

  lastName?: string

  indificationNo: string

  institutionName?: string

  passport?: string

  framework?: string

  updatedAt: Date

  phone?: string

  shiftId?: number

  learningShift?: CodeObject

  learnLocation?: string

  street?: string

  houseNumber?: string

  city?: string

  scholarship?: number

  datotRateId?: number

  datotRate?: CodeObject

  institutionId?: number

  isDuplicate: boolean

  loadStatuses?: string

  sourceExcelReportId?: number

  statusId?: number

  institution?: Institution

  isNeedPay?: boolean

  isReject?: boolean

  studentDatotComment?: string

  studentDatotCommentDate?: Date

  enrolledFromMonth?: number

  enrolledFromNumericYear?: number

  leftAtMonth?: number

  leftAtNumericYear?: number

  constructor(student: any, learningShifts: CodeObject[]) {
    this.id = student.Id
    this.firstName = student.FirstName
    this.lastName = student.LastName
    this.indificationNo = student.IndificationNo
    this.passport = student.Passport
    this.framework = student.Framework
    this.phone = student.Phone
    this.shiftId = student.ShiftId
    this.learnLocation = student.LearnLocation
    this.houseNumber = student.HouseNumber
    this.scholarship = student.Scholarship
    this.datotRateId = student.DatotRateId
    this.updatedAt = student.UpdatedAt
    this.institutionId = student.InstitutionId ?? student.Institution?.Id
    this.isDuplicate = student.IsDuplicate
    this.loadStatuses = student.LoadStatuses
    this.sourceExcelReportId = student.SourceExcelReportId
    this.city = student.City
    this.street = student.Street
    this.statusId = student.StatusId
    this.learningShift = learningShifts?.find(l => l.id === student.ShiftId)

    this.institutionName = student.Institution
      ? student.Institution?.Name
      : undefined
    this.isNeedPay = student.IsNeedPay
    this.isReject = student.IsReject
    this.studentDatotComment = student.StudentDatotComment
    this.studentDatotCommentDate = student.StudentDatotCommentDate
      ? new Date(student.StudentDatotCommentDate + 'Z')
      : undefined

    this.enrolledFromMonth = student.EnrolledFromMonth
    this.enrolledFromNumericYear = student.EnrolledFromNumericYear
    this.leftAtMonth = student.LeftAtMonth
    this.leftAtNumericYear = student.LeftAtNumericYear

    makeAutoObservable(this)
  }

  setReject = (isReject: boolean) => {
    this.isReject = isReject
  }

  setStatus = (statusId: number | undefined) => {
    this.statusId = statusId
  }

  setStudentDatotComment = (comment: string) => {
    this.studentDatotComment = comment
  }

  setStudentDatotCommentDate = (date: Date) => {
    this.studentDatotCommentDate = date
  }
}

export enum StudentTab {
  All = 1,
  Approved,
  Duplicate,
  Rejected,
  // Rows a reviewer pulled out of a student report — kept so they can be fixed and restored.
  Removed
}
